const CustomSelectElement = ({
  options,
  step,
  setStep = console.log,
  className,
  wrapperClassName,
  disabled,
}: any) => {
  function handleClick(active: any) {
    if (!disabled) {
      setStep(active);
    }
  }
  return (
    <div
      className={`flex-start-center gap-5 Max-sm:flex-col mb-8 mt-8 w-full ${
        disabled && "opacity-70"
      } ${wrapperClassName} `}
    >
      {options.map((item: any) => (
        <div
          key={item.active}
          onClick={() => handleClick(item.active)}
          className={`centering gap-2 py-2 border w-full rounded-full cursor-pointer transition duration-500 ${
            item.active === step ? "border-dark bg-dark bg-opacity-5" : ""
          } ${className}`}
        >
          {item.icon}
          <p
            className={`${
              item.active === step ? "text-dark" : "text-mainGray"
            }`}
          >
            {item.title}
          </p>
        </div>
      ))}
    </div>
  );
};

export default CustomSelectElement;
